export const $ = document.querySelector.bind(document);

export const $$ = (el: string) => {
  return Array.from(document.querySelectorAll(el));
};



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/utils/dom.ts